module.exports = __webpack_public_path__ + "img/g.29970a46.jpg";